import { Component, Inject, ViewChild } from "@angular/core";
import { UntypedFormBuilder, Validators } from "@angular/forms";
import {  MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Select, Store } from "@ngxs/store";
import {SaveChecklistTemplate, ChecklistTemplate, CommonService, ServiceLevel, Service, ChecklistTemplateItem} from 'huddyapi';
import { SavedProvider } from "../../settings/settings.component";
import { SelectionModel } from "@angular/cdk/collections";
import { MatTable } from "@angular/material/table";



@Component({
  selector: 'edit-checklist-templates-dialog',
  templateUrl: 'edit-checklist-templates-dialog.html',
  styleUrls: ["./edit-checklist-templates-dialog.scss"]
})
export class EditChecklistTemplatesDialog  {
  
  selection = new SelectionModel<ChecklistTemplateItem>(false, []);
  edited : ChecklistTemplate;
  provider : SavedProvider;
  services : Service[];
  items : ChecklistTemplateItem[];
  serviceLevels : ServiceLevel[];
  displayedColumns: string[] = ['select', 'item', 'service', 'required', 'requiredByAppNum'];
  lastAddedItem : number = -10;
  @ViewChild(MatTable) table: MatTable<any>;

  checklistTemplateForm = this.formBuilder.group({
    name: ['', [Validators.required, Validators.maxLength(50)]],
    template : '',
    service : {},
    item : '',
    selectedItem : {item : '', required : false, id : -1},
    required : '',
    requiredByAppNum: 1
});

  constructor(
    public dialogRef: MatDialogRef<EditChecklistTemplatesDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder : UntypedFormBuilder,
    private commonService : CommonService,
    public store : Store
  )
  {
    this.provider = data.provider;
 
    console.log('data', data);
    this.items = (data.checklistTemplate.items) ? [].concat(data.checklistTemplate.items) : [];
    this.sortItemsByReqApptByNum();
    this.checklistTemplateForm.setValue({
      name: data.checklistTemplate.name ?? '',
      template: '',
      service : {},
      item : '',
      selectedItem : {id : -1, item : ''},
      required : '',
      requiredByAppNum: this.getMaxReqApptByNum()+1,
     });
 
    this.edited = {
      name: data.checklistTemplate.name ?? '',
      providerId : this.provider.id,
      items : this.items,
      id : data.checklistTemplate.id ?? undefined,
      createdBy : data.checklistTemplate.createdBy ?? undefined,
      dateCreated : data.checklistTemplate.dateCreated ?? new Date().getTime()
    };
    console.log(this.edited);
    this.serviceLevels = [].concat(data.serviceLevels);
    this.services = [];
    for (let s of this.serviceLevels) {
      console.log(s, this.serviceLevels);
      this.services = this.services.concat(s.services);
    }


    this.provider = this.data.provider;
    console.log('provider=', this.provider, 'items', this.items);
  }

  ngOnInit(): void {
   console.log(this.edited);
  }

  isFormInValid() {
    return (this.checklistTemplateForm.invalid);
  }

  onSubmitForm() {
   this.save();
  }

  close() {
     
      this.dialogRef.close();
  }


  deleteItem() {
    const selectedItem = this.checklistTemplateForm.value.selectedItem;
    console.log('entering deleteItem', this.checklistTemplateForm.value.selectedItem);
    if (!selectedItem)
      return;

    const idx : number = this.items.findIndex(item => item.id === selectedItem.id);

    if (idx > -1) {
      this.items.splice(idx, 1);
      this.table.renderRows();
    }
  }


  getServices(): Service[] {
    return this.checklistTemplateForm.value.services;
  }
  getItems(): ChecklistTemplateItem[] {
    return this.edited.items;
  }



  save() {

      console.log('entering save', this.items);
      let g : ChecklistTemplate = ({
        id: (this.edited.id && this.edited.id > -1) ? this.edited.id : null,
        name : this.checklistTemplateForm.value.name,
        providerId : this.provider.id,
        createdBy:  (this.edited.id && this.edited.id > -1) ? this.edited.createdBy : this.commonService.getCurrentUserToView(),
        dateCreated : (this.edited.id && this.edited.id > -1) ? this.edited.dateCreated : new Date().getTime(),
        items : this.items.map(item =>({
            id : undefined,
            checklistTemplateId: this.edited.id,
            serviceId : item.serviceId,
            item: item.item,
            required: item.required,
            requiredByAppNum: item.requiredByAppNum
        }))
      });
    console.log('Checklist template to save', g);  
    this.store.dispatch(new SaveChecklistTemplate(g)).subscribe(t => {
          this.close();
        });
  }

  onItemSelected($event, row) {
    if ($event) {
      this.selection.toggle(row);
      if ($event.checked) {
        this.checklistTemplateForm.controls.selectedItem.setValue(row);
        this.checklistTemplateForm.controls.item.setValue(row.item);
        let service : Service = this.services.find(s => s.id === row.serviceId);
        console.log('service', service, row.serviceId, this.services);
        this.checklistTemplateForm.controls.service.setValue(service);
        this.checklistTemplateForm.controls.required.setValue(row.required);
        this.checklistTemplateForm.controls.requiredByAppNum.setValue(row.requiredByAppNum);
      }
    } 
  }

  getServiceName(serviceId : number) {
    const service : Service = this.services.find(s => s.id === serviceId);
    return service ? service.name : '';
  }

  getMaxReqApptByNum() : number {
    return Math.max.apply(null,
      this.items.map(function (o) { return o.requiredByAppNum; }));
  }

  sortItemsByReqApptByNum() {
    this.items.sort((a, b) => {
      if (!a.requiredByAppNum && b.requiredByAppNum) {
        return 1;
      }
      if (a.requiredByAppNum && !b.requiredByAppNum) {
        return -1;
      }
      if (a.requiredByAppNum < b.requiredByAppNum) {
          return -1;
      }
      if (a.requiredByAppNum > b.requiredByAppNum) {
          return 1;
      }
      return 0;
  });
  }

  hasCompleteItem() : boolean {
    const item : string = this.checklistTemplateForm.value.item;
    const required : boolean =  this.checklistTemplateForm.value.required ;
    const serviceId : number = this.checklistTemplateForm.value.service ?
     this.checklistTemplateForm.value.service.id : undefined;
    const requiredByAppNum : number = this.checklistTemplateForm.value.requiredByAppNum;
    return (item && (item.length > 0) && (required != undefined) && (serviceId != undefined) && (!required || (required && requiredByAppNum && requiredByAppNum > 0)));
  }

  createNewItem() {
    this.selection.clear();
    this.checklistTemplateForm.controls.selectedItem.setValue({id : -1, item: ''});
    this.checklistTemplateForm.controls.item.setValue('');
    this.checklistTemplateForm.controls.required.setValue(false);
    this.checklistTemplateForm.controls.service.setValue(undefined);
    this.checklistTemplateForm.controls.requiredByAppNum.setValue(this.getMaxReqApptByNum()+1);
  }



  saveItem() {
    console.log('entering saveItem');
    let item : ChecklistTemplateItem = this.checklistTemplateForm.value.selectedItem;
    console.log('selected', item);
    item.item = this.checklistTemplateForm.value.item;
    item.required = this.checklistTemplateForm.value.required;
    item.requiredByAppNum = this.checklistTemplateForm.value.requiredByAppNum;
    item.serviceId = this.checklistTemplateForm.value.service.id;
    if (item.id === -1) {
      item.id = this.lastAddedItem--;
      this.items.push(item);
      console.log('added item', item, this.items);
    }
    this.sortItemsByReqApptByNum(); 
    this.table.renderRows();
   
  }

}

